var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('headNavBar',{attrs:{"title":"关于我们","fixed":true}}),_c('div',{staticClass:"mt-header-nav"},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":_vm.versionConfig.ZHIYUN_VERSION
            ? ("/image/" + (_vm.appConfig.logo ? _vm.appConfig.logo : 'zy_logo.png'))
            : '/image/hy_logo.png'}})]),_c('p',{staticClass:"intro"},[_vm._v("\n      更专业的住宿管理系统——"+_vm._s(_vm.versionConfig.ZHIYUN_VERSION
          ? _vm.appConfig.title
            ? _vm.appConfig.title
            : "智云Plus"
          : "鸿云PMS")+"，适用于民宿、客栈、酒店，为每一位客户提供领先的住宿信息化一体解决方案。\n    ")]),_c('p',{staticClass:"intro"},[_vm._v("\n      公司专注酒店管理软件16年，坚守技术立命初心，持续为数千家民宿及酒店提供服务，行业积累深，用户更认可，实力更靠谱。\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }